var _mask, _rect, _rect2, _rect3, _mask2, _rect4, _rect5, _rect6, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTranscode(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_8801_14163",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 30,
    height: 20,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 30,
    height: 20,
    rx: 2,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 30,
    height: 20,
    rx: 2,
    stroke: "url(#paint0_linear_8801_14163)",
    strokeWidth: 6,
    mask: "url(#path-1-inside-1_8801_14163)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 30,
    height: 20,
    rx: 2,
    stroke: "#6F00DE",
    strokeOpacity: 0.2,
    strokeWidth: 6,
    mask: "url(#path-1-inside-1_8801_14163)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_8801_14163",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 9.5,
    width: 18,
    height: 12,
    rx: 2
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 9.5,
    width: 18,
    height: 12,
    rx: 2,
    fill: "none"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 9.5,
    width: 18,
    height: 12,
    rx: 2,
    stroke: "url(#paint1_linear_8801_14163)",
    strokeWidth: 6,
    mask: "url(#path-2-inside-2_8801_14163)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 9.5,
    width: 18,
    height: 12,
    rx: 2,
    stroke: "#6F00DE",
    strokeOpacity: 0.2,
    strokeWidth: 6,
    mask: "url(#path-2-inside-2_8801_14163)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8801_14163",
    x1: 2,
    y1: 10.2439,
    x2: 32,
    y2: 10.2439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D273FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FF5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FF5D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8801_14163",
    x1: 0,
    y1: 15.6463,
    x2: 18,
    y2: 15.6463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D273FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FF5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FF5D6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranscode);
export default __webpack_public_path__ + "static/media/transcode.d5f7322fa92ddf994b622be77b964d2f.svg";
export { ForwardRef as ReactComponent };